import { Select } from 'antd';
import { useGetLocationsQuery } from 'gql/types';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ILocationMultiSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  regionIds?: string[];
  loading?: boolean;
  placeholder?: string;
}

export const LocationSelect: FC<ILocationMultiSelectProps> = ({
  value,
  onChange,
  regionIds = [],
  loading = false,
  placeholder,
}) => {
  const { t } = useTranslation('dashboard.RecruiterDashboard');

  const { data, loading: locationsLoading } = useGetLocationsQuery({
    variables: {
      input: {
        take: 1000,
        filter: {
          regionIds: regionIds.length > 0 ? regionIds : undefined,
        },
      },
    },
  });

  const options = useMemo(
    () =>
      data?.getLocations.data.map((location) => ({
        value: location.id,
        label: location.name,
      })) || [],
    [data]
  );

  return (
    <Select
      mode="multiple"
      allowClear
      showSearch
      optionFilterProp="label"
      value={value}
      onChange={onChange}
      options={options}
      loading={loading || locationsLoading}
      placeholder={placeholder ?? t('filtersAllLocations', 'All Locations')}
      style={{ width: '100%', minWidth: 200 }}
      maxTagCount="responsive"
    />
  );
};

export default LocationSelect;
